import { GET_BY_USER_ID_CONFIGURATION, UPDATE_USER_CONFIGURATION, GET_ERRORS } from './types';
import { getErrorMessage } from '../utils/util.errors';
import services from '../config/services';
import axios from 'axios';

const URL_GET_BY_USER_ID_CONFIGURATION = process.env.REACT_APP_API_URL + services.getUserConfigurationById;
const URL_UPDATE_USER_CONFIGURATION    = process.env.REACT_APP_API_URL + services.updateUserConfiguration;

export const getByUserId = (userId) => dispatch => {
	const url = URL_GET_BY_USER_ID_CONFIGURATION + '?user_id=' + userId;
	axios.get(url).then(res => {
        dispatch({
            type:    GET_BY_USER_ID_CONFIGURATION,
            payload: res.data.result
        })
	}).catch(error => {
		dispatch({
            type:    GET_ERRORS,
            payload: getErrorMessage(error)
		})
	});
};

export const updateUserConfiguration = (userConfiguration) => dispatch => {
	axios.put(URL_UPDATE_USER_CONFIGURATION, userConfiguration).then(res => {
		dispatch({
            type:    UPDATE_USER_CONFIGURATION,
            payload: res.result
		})
	}).catch(error => {
        dispatch({
            type:    GET_ERRORS,
            payload: getErrorMessage(error)
        })
	});
}